import { Auth, Storage } from 'aws-amplify';

/**
 * Retrieves the signed URL of the signed-in user's avatar image from protected S3 storage. Reads the authenticated Cognito user bypassing the cache, fetches avatar.png under that user's identity id, and logs and returns null on failure.
 *
 * @returns Signed avatar URL, or null when it could not be resolved.
 */
const getUserAvatar = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
    const avatar = await Storage.get('avatar.png', {
      level: 'protected',
      identityId: currentUser?.attributes?.sub,
    });
    return avatar;
  } catch (error) {
    console.error('Failed to get avatar: ', error);
    return null;
  }
};

export default getUserAvatar;
